import 'array-from-polyfill';
import 'fetch-polyfill';

import { onDomReady } from '@grrr/ready';
import { enhance, handle } from '@grrr/hansel';
import { autoTargetBlankEnhancer } from './modules/auto-target-blank';
import { cleanWarningsAfterNewInputEnhancer } from './modules/form-helpers';
import { clickOutside } from './modules/click-outside';
import { conditionalFieldEnhancer } from './modules/conditional-field-enhancer.js';
import { slideNextHandler } from './modules/slide';
import {
    showElementHandler,
    totalBondValueEnhancer,
} from './modules/subscribe-as-guest';
import {
    calculateTotalEnhancer,
    numberFieldManipulatorHandler,
    showGetNewCodeEnhancer,
} from './modules/subscribe-by-extending';
import { default as subMenu } from './modules/sub-menu';
import { preventDoubleSubmitEnhancer } from './modules/prevent-double-submit';
import { toggleAttribute } from './modules/toggle-attribute';
import {
    transactionOverviewEnhancer,
    toggleTransactionHandler,
} from './modules/transaction-overview.js';

const addClassOnLoad = function (el) {
    const className = el.getAttribute('data-class');
    el.classList.add(`js-${className}`);
};

/**
 * Import all images and fonts to make Vite aware of your assets by importing the static assets.
 */
import.meta.glob([
    '../images/**',
    '../fonts/**',
    '../landing-pages/images/**',
    '../landing-pages/fonts/**',
]);

onDomReady(() => {
    subMenu.init();
    enhance(document.documentElement, {
        addClassOnLoad,
        autoTargetBlankEnhancer,
        calculateTotalEnhancer,
        cleanWarningsAfterNewInputEnhancer,
        conditionalFieldEnhancer,
        preventDoubleSubmitEnhancer,
        showGetNewCodeEnhancer,
        totalBondValueEnhancer,
        transactionOverviewEnhancer,
    });

    handle(document.documentElement, {
        numberFieldManipulatorHandler,
        showElementHandler,
        slideNextHandler,
        clickOutside,
        toggleAttribute,
        toggleTransactionHandler,
    });
});
